import { render, staticRenderFns } from "./order.vue?vue&type=template&id=5df8cc87&"
import script from "./order.vue?vue&type=script&lang=coffee&"
export * from "./order.vue?vue&type=script&lang=coffee&"
import style0 from "./order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports